import { TColumn, TableColumn } from "./types";

import { GeneralReportType } from "_graphql/__generated__/globalTypes-kek";
import { Treaty_treaty } from "_graphql/queries/__generated__/Treaty";
import { getDomain } from "router/filter";

export { default as classNames } from "./classnames";
export { default as wrapClick } from "./wrap-click";
export { default as wrapImage } from "./wrap-image";
export { default as wrapOnchange } from "./wrap-onchange";
export { default as useDownloadFile } from "./use-download-file";
export { default as useUrlState } from "./use-url-state";
export { default as useTableData } from "./use-table-data";
export { default as withPermissions } from "./with-roles";

export * as validators from "./regex";

export const AccountPeriodsNames = {
  FIRSTQUARTER: "1st Quarter",
  SECONDQUARTER: "2nd Quarter",
  THIRDQUARTER: "3rd Quarter",
  FOURTHQUARTER: "4th Quarter",
};

export const domainTheme = {
  KEK: "",
  Visal: "dark",
  Comfy: "theme-forest-sage",
};

export const getAccountPeriodLabel = (period: string) => {
  return (AccountPeriodsNames as any)[period] || period;
};

export const getLayerParticipantsPercentageTotal = (
  treaty: Treaty_treaty | undefined | null,
  layerNumber: number
) => {
  return (
    treaty?.treaty_participants?.reduce((acc, cur) => {
      if (cur?.layer_number === layerNumber) {
        return acc + (cur?.treaty_participation_percentage || 0);
      }
      return acc;
    }, 0) || 0
  );
};

export const facultativeReportOptions = [
  {
    label: "Closed Offers",
    value: "CLOSED",
  },
  {
    label: "Expired Offers",
    value: "EXPIRED",
  },
  {
    label: "Expiring Offers",
    value: "EXPIRING",
  },
  {
    label: "Offers Created",
    value: "CREATED",
  },
];

export const facultativeReportTypeOptions = [
  {
    label: "Uncleared Cheques",
    value: GeneralReportType.UNCLEARED,
  },
  {
    label: "Cleared Cheques",
    value: GeneralReportType.CLEARED,
  },
  {
    label: "Premium paid to reinsurers",
    value: GeneralReportType.RE_PREMIUM_PAID,
  },
  {
    label: "Premium due to reinsurers",
    value: GeneralReportType.RE_PREMIUM_OUTSTANDING,
  },
];

export const reinsurerTable: TableColumn<TColumn<unknown>> = [
  {
    label: "Policy #",
    accessor: "policy_number",
    name: "policy_number",
  },
  {
    label: "Reinsurer",
    accessor: "re_company_name",
    name: "re_company_name",
  },
  {
    label: "Insured",
    accessor: "insured_by",
    name: "insured_by",
  },
  {
    label: "Business Name",
    accessor: "business_name",
    name: "business_name",
  },
  {
    label: "Business State",
    accessor: "business_state",
    name: "business_state",
  },
  {
    label: "Currency",
    accessor: "currency",
    name: "currency",
  },
  {
    label: "Total Sum Insured",
    accessor: "sum_insured",
    name: "sum_insured",
  },
  {
    label: "Fac. Sum Insured",
    accessor: "fac_sum_insured",
    name: "fac_sum_insured",
  },
  {
    label: "Fac. Premium",
    accessor: "fac_premium",
    name: "fac_premium",
  },
  {
    label: "Brokerage",
    accessor: "brokerage_amount",
    name: "brokerage_amount",
  },
  {
    label: "Outstanding Brokerage Amount",
    accessor: "outstanding_brokerage_amount",
    name: "outstanding_brokerage_amount",
  },
  {
    label: "Premium due KEK",
    accessor: "expected_amount",
    name: "expected_amount",
  },
  {
    label: "Outstanding premium",
    accessor: "outstanding_amount",
    name: "outstanding_amount",
  },
  {
    label: "Period of Insurance",
    accessor: "period",
    name: "period",
  },
  {
    label: "Placed Share",
    accessor: "placed_offer",
    name: "placed_offer",
  },
  {
    label: "Offer Status",
    accessor: "offer_status",
    name: "offer_status",
  },
  {
    label: "Payment Status",
    accessor: "payment_status",
    name: "payment_status",
  },
  {
    label: "Offer Date",
    accessor: "created_at",
    name: "created_at",
  },
  {
    label: "Closed Date",
    accessor: "closed_date",
    name: "closed_date",
  },
  {
    label: "END",
    accessor: "hasEndorsement",
    name: "hasEndorsement",
  },
];

export const insurerTable: TableColumn<TColumn<unknown>> = [
  {
    label: "Policy #",
    accessor: "policy_number",
    name: "policy_number",
  },
  {
    label: "Insurer",
    accessor: "insurer_company_name",
    name: "insurer_company_name",
  },
  {
    label: "Insured",
    accessor: "insured_by",
    name: "insured_by",
  },
  {
    label: "Business Name",
    accessor: "business_name",
    name: "business_name",
  },
  {
    label: "Business State",
    accessor: "business_state",
    name: "business_state",
  },
  {
    label: "Currency",
    accessor: "currency",
    name: "currency",
  },
  {
    label: "Total Sum Insured",
    accessor: "sum_insured",
    name: "sum_insured",
  },
  {
    label: "Fac. Sum Insured",
    accessor: "fac_sum_insured",
    name: "fac_sum_insured",
  },
  {
    label: "Fac. Premium",
    accessor: "fac_premium",
    name: "fac_premium",
  },
  {
    label: "Brokerage",
    accessor: "brokerage_amount",
    name: "brokerage_amount",
  },
  {
    label: "Outstanding Brokerage Amount",
    accessor: "outstanding_brokerage_amount",
    name: "outstanding_brokerage_amount",
  },
  {
    label: "Premium due KEK",
    accessor: "expected_amount",
    name: "expected_amount",
  },
  {
    label: "Outstanding premium",
    accessor: "outstanding_amount",
    name: "outstanding_amount",
  },
  {
    label: "Period of Insurance",
    accessor: "period",
    name: "period",
  },
  {
    label: "Placed Share",
    accessor: "placed_offer",
    name: "placed_offer",
  },
  {
    label: "Offer Status",
    accessor: "offer_status",
    name: "offer_status",
  },
  {
    label: "Payment Status",
    accessor: "payment_status",
    name: "payment_status",
  },
  {
    label: "Offer Date",
    accessor: "offer_date",
    name: "offer_date",
  },
  {
    label: "Closed Date",
    accessor: "closed_date",
    name: "closed_date",
  },
  {
    label: "END",
    accessor: "hasEndorsement",
    name: "hasEndorsement",
  },
];

export const generateURlData = (data: any) => {
  return Buffer.from(JSON.stringify(data)).toString("base64");
};

export const extractVehicleNumberFromDetails = (details: any) => {
  return details?.find(
    (el: { [x: string]: string }) =>
      el?.["keydetail"] === "Vehicle Reg No" ||
      el?.["keydetail"] === "Vehicle Reg No."
  )?.value;
};

export const isDevelopment =
  window.location.hostname === "localhost" ||
  window.location.hostname.includes("dev");

export const getSumOFNPPayments = ({
  treaty_np_payments = [],
  uuid,
  treaty_np_payment_id,
  installment_type,
}: any) => {
  const sum = treaty_np_payments.reduce((acc: number, curr: any) => {
    const details = JSON.parse(curr.treaty_payment_details || "{}");
    const { conversion } = details;

    // Skip the current payment to avoid double-counting
    if (Number(curr.treaty_np_payment_id) === Number(treaty_np_payment_id)) {
      return acc;
    }

    // Only sum payments for the matching installment_type
    if (curr.installment_type?.toString() !== installment_type) {
      return acc;
    }

    const rawAmount = parseFloat(curr.treaty_payment_amount);
    if (isNaN(rawAmount)) return acc;

    if (conversion?.addExchangeRate && parseFloat(conversion.rate)) {
      const rate = parseFloat(conversion.rate);
      return acc + rawAmount / rate;
    }

    return acc + rawAmount;
  }, 0);

  return sum;
};

export const getSumOFPPayments = ({
  treaty_np_payments = [],
  treaty_p_payment_id,
  treaty_account_id,
}: {
  treaty_np_payments: any[];
  treaty_p_payment_id?: any;
  treaty_account_id: string;
}) => {
  const sum = treaty_np_payments
    ?.filter((el) => el?.treaty_accountstreaty_account_id === treaty_account_id)
    .reduce((acc, curr) => {
      const details = JSON.parse(curr.treaty_payment_details);
      const { conversion } = details;
      if (treaty_p_payment_id === curr.treaty_p_payment_id) {
        return acc;
      }
      if (conversion && conversion.addExchangeRate) {
        return (
          acc +
          parseFloat(curr.treaty_payment_amount) / parseFloat(conversion.rate)
        );
      }

      return acc + parseFloat(curr.treaty_payment_amount);
    }, 0);

  return sum;
};

export const filterListByCurrentDomain = <T extends { domain: string[] }>(
  list: T[]
) => {
  const domain = getDomain();
  return list.filter((item) => item.domain.includes(domain));
};

const items = [
  {
    id: 1,
    name: "Item 1",
    domain: ["KEK", "Visal"],
  },
  {
    id: 2,
    name: "Item 2",
    domain: ["KEK"],
  },
  {
    id: 3,
    name: "Item 3",
    domain: ["domain1"],
  },
];
